module.exports = __webpack_public_path__ + "media/static/icons/icon-legend-swell-arrow-e60c7e206e4d7d88918211694a824702.svg";